import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { socket } from 'api';
import { GrayButton } from 'libs/ui';
import { Content, Title, Select, Block } from './option-receipt.styled';

export const OptionReceipt = ({ sendControlMsg, templateId }) => {
  const { t } = useTranslation();
  const [items, setItems] = useState(null);
  const [value, setValue] = useState(templateId ?? '');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const updateItems = (data) => {
      setItems(data.items);
    };

    const setLoadingOff = () => {
      // console.log('🚀 ~ setLoadingOff ~ msg:', msg);
      setTimeout(() => setLoading(false), 250);
    };

    const updateSocketState = () => {
      sendControlMsg('get_state');
    };

    socket.on('racks.set_receipt_template', updateSocketState);
    socket.on('get_state', setLoadingOff);
    socket.on('receipt_template.list', updateItems);
    socket.call('receipt_template.list', { filter_params: {}, sort_params: [], paging_params: { limit: 100, offset: 0 } });

    return () => {
      socket.off('racks.set_receipt_template', updateSocketState);
      socket.off('get_state', setLoadingOff);
      socket.off('receipt_template.list', updateItems);
    };
  }, []);

  /**
   * change enabled
   * @param {*} event
   */
  const setTemplate = () => {
    setLoading(true);
    sendControlMsg('racks.set_receipt_template', { receipt_template_id: value ? parseInt(value) : null });
  };

  /**
   * change value
   * @param {*} event
   * @returns
   */
  const onChange = (event) => {
    const val = event.target.value;
    setValue(val);
    // setLoading(true);
    // sendControlMsg('settings.set_vehicle_plate_check', { enable: limitEnabled, distance: val });
  };

  const getItemsEl = () => {
    return items.map((el, idx) => {
      return (
        <option value={el.receipt_template_id} key={idx}>
          {el.name}
        </option>
      );
    });
  };

  if (!items) {
    return null;
  }
  const itemsEl = getItemsEl();
  const cl = loading ? 'loading' : '';

  return (
    <Content className={cl}>
      <Title>{t('forms.Шаблон билета')}</Title>
      <Block>
        <Select value={value} onChange={onChange}>
          <option value="">{t('forms.Системный шаблон')}</option>
          {itemsEl}
        </Select>
        <GrayButton onClick={setTemplate}>{t('buttons.Установить')}</GrayButton>
      </Block>
    </Content>
  );
};
